/**
 * Returns a shallow copy of the object with all null, undefined, and empty-string
 * fields removed. Valid falsy values — false, 0, empty arrays — are preserved.
 */
export function cleanPayload<T extends Record<string, unknown>>(obj: T): Partial<T> {
  const result: Partial<T> = {};

  for (const key of Object.keys(obj) as Array<keyof T>) {
    const value = obj[key];

    if (value !== null && value !== undefined && value !== '') {
      result[key] = value;
    }
  }

  return result;
}
